import React, { PropsWithChildren } from 'react';
import theme from './Content.module.scss';
import { classnames } from '@/utils/html';
import { useIsBuyer, useIsSeller, useIsWhiteLabel } from '@/utils/hooks';
import { use100vh } from 'react-div-100vh';

interface ContentProps extends PropsWithChildren {}

const Content: React.FC<ContentProps> = ({ children }) => {
    const isBuyer = useIsBuyer();
    const isSeller = useIsSeller();
    const height = use100vh();
    const isWhiteLabel = useIsWhiteLabel();

    return (
        <div
            style={{
                minHeight: height ? `calc(${height}px - var(--cm-header-height))` : '100vh',
                maxWidth: isBuyer ? 'var(--buyer-max-content-width)' : undefined,
            }}
            className={classnames(theme.container, {
                [theme.seller]: isSeller,
                [theme.isBuyer]: isBuyer,
                [theme.whiteLabel]: isWhiteLabel,
            })}>
            {children}
        </div>
    );
};

export default Content;
